<template>
  <div class="content" id="test">
    <div class="article">
      <!-- <h3 style="text-align:center">{{ list.title }}</h3> -->
      <div class="author">
        <p style="">
          <img src="" alt="" /> <span>{{ list.author }}</span>
        </p>
        <p class="addTime">{{ time }}</p>
      </div>
      <div class="box" ref="box" v-html="list.content"></div>
      <div class="evaluate">
        <p></p>
        <p class="p2">
          <span><van-icon name="eye" size="0.6rem" />{{ list.hit }}</span>
          <span>
            <van-icon
              :name="isLike == 1 ? 'good-job' : 'good-job-o'"
              :color="isLike == 1 ? '#FFE339' : ''"
              size="0.6rem"
              @click="getLike()"
            />{{ list.likeCounts }}</span
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import checkDevice from "../../tools/app";
export default {
  data() {
    return {
      id: this.$route.params.id,
      list: [],
      isLike: "",
      userId: "",
      time: "",
    };
  },
  created() {
    window["callJsFunction"] = this.callJsFunction;
    this.getList();
  },

  methods: {
    callJsFunction(str) {
      //判断系统函数
      let phone = checkDevice();
      if (phone == "ios") {
        this.userId = str;
      } else {
        this.userId = str;
      }
    },
    //  请求数据
    getList() {
      this.$post({
        url: "owsHomePage/homePageDetailById/" + this.id,
        method: "get",
        params: {
          userId: this.userId,
        },
      })

        .then((res) => {
          if (res.retCode == 200) {
            this.list = res.data.code;
            this.isLike = this.list.isLike;
            let date = new Date(res.data.code.is_add_time);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            this.time = `${year}-${month}-${day}`;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //  点赞
    getLike() {
      this.$post({
        url: "owsHomePage/isLike",
        method: "post",
        params: {
          articleId: this.list.article_id,
          userId: this.userId,
        },
      })
        .then((res) => {
          if (res.data.retCode == 800201) {
            this.isLike = 1;
            this.list.likeCounts++;
            this.$toast(res.data.message);
          } else {
            this.isLike = 0;
            this.list.likeCounts--;
            this.$toast(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #ffffff;
  }
  .video {
    padding: 0.2667rem;
    text-align: center;
    background-color: white;
  }
  .article {
    background-color: white;
    padding: 0.4rem 0.4rem 1rem 0.4rem;
    .author {
      margin-top: 0.4667rem;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .addTime {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 0.3733rem;
        color: #999999;
      }
    }
  }
  .box {
    overflow: hidden;
    /deep/img {
      width: 100% !important;
    }
  }
  .evaluate {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.4rem;
    // padding: 0 0.5333rem;
    .p2 {
      display: flex;
      align-items: center;
      font-size: 0.48rem;
      span {
        margin-left: 0.4rem;
        display: flex;
        align-items: center;
      }
      i {
        margin-right: 0.1333rem;
      }
    }
  }
  .shop {
    margin-top: 0.2667rem;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4533rem;
    .shop-top {
      margin-right: 2.3rem;
      .p1 {
        font-weight: 600;
        color: #333;
      }
      .p2 {
        margin-top: 0.4rem;
        font-weight: 500;
        color: #f5492c;
      }
    }
    img {
      width: 1.8667rem;
      height: auto;
    }
  }
  /deep/.van-nav-bar .van-icon {
    color: black;
    font-size: 0.875rem;
  }
}
</style>
